//https://www.notion.so/qonto/Destination-names-for-integrations-object-d4edabdceb474ca288948e09cbf441e9
export const CONSENT_IS_REQUIRED_VENDORS = {
  // Tracking pixels injected to OrganizationCongratsRoute
  AWIN: { id: 'c:awin-964zLYt8', name: 'Awin' },
  AFINIA: { id: 'c:afinia-xiiQGwqD', name: 'Afinia' },
  AFFILAE: { id: 'c:affilae', name: 'Affilae' },
  DIGITAL_WINDOW: { id: 'c:digital-window', name: 'Digital Window' },
  LINKEDIN: { id: 'c:linkedin', name: 'LinkedIn' },
  FINANCE_ADS: { id: 'c:financeads', name: 'Finance Ads' },
  TRADE_DOUBLER: { id: 'c:tradedoub-gykjz24Z', name: 'Trade Doubler' },

  // Segment vendors according to Growth Team:
  // https://www.notion.so/qonto/Destination-names-for-integrations-object-d4edabdceb474ca288948e09cbf441e9
  AMPLITUDE: { id: 'c:amplitude', name: 'Amplitude' },
  AMPLITUDE_ACTIONS: { id: 'c:amplitude', name: 'Amplitude (Actions)' },
  BING_ADS: { id: 'c:bing-ads', name: 'Bing Ads' },
  GOOGLE_ADS_GTAG: { id: 'google', name: 'Google Ads (Gtag)' },
  GOOGLE_ADWORDS_NEW: { id: 'google', name: 'Google AdWords New' },
  GOOGLE_ADS_CLASSIC: { id: 'google', name: 'Google Ads (Classic)' },
  GOOGLE_ADWORDS: { id: 'google', name: 'AdWords' },
  GOOGLE_ANALYTICS: { id: 'google', name: 'Google Analytics' },
  GOOGLE_ANALYTICS_4: { id: 'google', name: 'Google Analytics 4' },
  GOOGLE_ENHANCED_CONVERSIONS: { id: 'google', name: 'Google Enhanced Conversions' },
  CONVERSION_FUNCTIONS_FOR_GOOGLE_ADS: {
    id: 'google',
    name: 'Conversion Functions for Google Ads',
  },
  FACEBOOK_PIXEL: { id: 'c:fb-ads', name: 'Facebook Pixel' },
  FACEBOOK_CONVERSIONS_API: { id: 'c:fb-ads', name: 'Facebook Conversions API' },
  LINKEDIN_INSIGHT_TAG: { id: 'c:linkedin', name: 'LinkedIn Insight Tag' },
  TWITTER_ADS: { id: 'c:twitter', name: 'Twitter Ads' },
  SNAPCHAT_CONVERSIONS_API: { id: 'c:snapchat', name: 'Snapchat Conversions API' },
};

// Just for reference, these are technical tools
// and we don't need consent for them (according to our legal)
// but we need to send them to Segment
export const TECHNICAL_VENDORS = {
  JUNE: { id: 'c:june', name: 'June' },
  CUSTOMER_IO: { id: 'c:customer-io', name: 'Customer.io' },
  CUSTOMER_IO_ACTIONS: { id: 'c:customer-io', name: 'Customer.io (Actions)' },
  SALESFORCE: { id: 'c:salesforce', name: 'Salesforce' },
  SNOWFLAKE: { id: 'c:snowflake', name: 'Snowflake' },
  HOTJAR: { id: 'c:hotjar', name: 'Hotjar' },
  SENTRY: { id: 'c:sentry', name: 'Sentry' },
  SEGMENT_IO: { id: 'c:segment', name: 'Segment.io' },
  AB_TASTY: { id: 'c:ab-tasty', name: 'ABTasty' },
  AB_TASTY_CLIENT_SIDE: { id: 'c:ab-tasty', name: 'AB Tasty client side' },
  GOOGLE_FONTS: { id: 'c:g-fonts', name: 'Google Fonts' },
  GOOGLE_TAG_MANAGER: { id: 'c:g-tag', name: 'Google Tag Manager' },
};
